import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import staffSearch from '_c/staff-search';
import { downloadPayslipList, downloadPdf as _downloadPdf, sendPdfToEmail as _sendPdfToEmail, downloadPayslipZip } from 'api/payroll/pay-slip';
export default {
  components: {
    staffSearch: staffSearch
  },
  data: function data() {
    return {
      ruleForm: {
        staff_info_id: null,
        pay_month: null,
        sort: null,
        dir: null
      },
      loading: false,
      tableData: [],
      dialogVisible: false,
      row: {},
      email: {
        type: '',
        value: ''
      }
    };
  },
  methods: {
    handlerBack: function handlerBack() {
      this.$router.push({
        path: '/payroll/pay-slip'
      });
    },
    // 选择员工信息
    staffChange: function staffChange(val) {
      this.ruleForm.staff_info_id = val.staff_id;
    },
    // 全部下载
    handleCommand: function handleCommand(type) {
      var _this = this;
      downloadPayslipZip({
        is_combine: type,
        staff_info_id: this.ruleForm.staff_info_id,
        pay_month: this.ruleForm.pay_month
      }).then(function (_ref) {
        var data = _ref.data;
        if (data) _this.$message.success(_this.$t('payroll_salary_27'));
      });
    },
    // 查询
    onSearch: function onSearch() {
      var _this2 = this;
      // 员工姓名和记薪月份输入一个
      if (!this.ruleForm.pay_month && !this.ruleForm.staff_info_id) return this.$message.warning(this.$t('pay_slip_45'));
      var query = {};
      if (this.ruleForm.pay_month) query.pay_month = this.ruleForm.pay_month;
      if (this.ruleForm.staff_info_id) query.staff_info_id = this.ruleForm.staff_info_id;
      if (this.ruleForm.sort) query.sort = this.ruleForm.sort;
      if (this.ruleForm.dir) {
        if (this.ruleForm.dir === 'ascending') query.dir = 'asc';
        if (this.ruleForm.dir === 'descending') query.dir = 'desc';
      }
      downloadPayslipList(query).then(function (data) {
        if (data.code === 1 && data.data) {
          _this2.tableData = data.data;
        }
      });
    },
    handlerSort: function handlerSort(_ref2) {
      var prop = _ref2.prop,
        order = _ref2.order;
      // 排序
      this.ruleForm.sort = prop;
      this.ruleForm.dir = order;
      this.onSearch();
    },
    changeType: function changeType() {
      // 选择发送方式
      this.email.value = this.row[this.email.type] || '';
    },
    onEmail: function onEmail(row) {
      // 发送邮箱
      this.dialogVisible = true;
      this.row = row;
    },
    sendPdfToEmail: function sendPdfToEmail() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.$refs.emailForm.validate(function (valid) {
                if (valid) {
                  _this3.loading = true;
                  var query = {
                    payslip_staff_id: _this3.row.payslip_staff_id,
                    email: _this3.email.value
                  };
                  _sendPdfToEmail(query).then(function (res) {
                    if (res && res.data) {
                      _this3.handleClose();
                      _this3.$notify({
                        message: _this3.$t('pay.slip.3'),
                        duration: 5000,
                        type: 'success'
                      });
                    }
                  }).finally(function () {
                    _this3.loading = false;
                  });
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    downloadPdf: function downloadPdf(row) {
      var _this4 = this;
      _downloadPdf({
        payslip_staff_id: row.payslip_staff_id
      }).then(function (res) {
        if (res && res.data) window.open(res.data, '_blank');
      }).finally(function () {
        _this4.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.$refs.emailForm.resetFields();
      this.dialogVisible = false;
    }
  }
};